/* ==========================================================================
   Size guide drawer

   JS'in isi:
     1. drawer'i <body>ye tasimak  - transform uygulanmis bir ata
        position: fixed'i ve dialog konumlandirmasini bozar,
     2. sekme <-> panel eslesmesi,
     3. secili varyantla eslesen sekmeyi acmak,
     4. galerideki "Dimensions" slide'inda secili olcuyu gostermek ve
        olcu chip'lerini buy box'taki Size secimine baglamak,
     5. slide'in boyu galeriyi buyuttugunde sayfayi yerinde tutmak,
     6. thumb'dan acilinca ya da chip secilince satirlari ekranda (yuzen
        sepet cubugunun ustunde) tutmak.

   (3) CANLI INPUT DEGERINE karsi yapilir, Liquid'de degil: varyant AJAX ile
   degistiginde Liquid'den gelen "secili" bilgisi bayatlar.

   Birim degistirme bu dosyanin isi DEGIL. Mevcut switch (assets/size-unit-switch.js)
   <html> uzerindeki unit-in / unit-cm sinifini yonetir; guide ayni .iwa-unit
   siniflarini kullandigi icin CSS uzerinden otomatik doner.
   ========================================================================== */

(function () {
  'use strict';

  var moved = new WeakSet();

  function panels(dialog) {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('[data-size-guide-panel]')
    );
  }

  function tabs(dialog) {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('[data-size-guide-tab]')
    );
  }

  function activate(dialog, index) {
    tabs(dialog).forEach(function (tab) {
      var on = tab.getAttribute('data-size-guide-tab') === String(index);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels(dialog).forEach(function (panel) {
      var on = panel.getAttribute('data-size-guide-panel') === String(index);
      if (on) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  /* Su an secili olan tum secenek degerleri. Size her zaman radio olarak
     render edilir, ama <select> de olabilecegi icin ikisi de taranir. */
  function selectedValues() {
    var out = [];
    document
      .querySelectorAll('.variant-input-wrap input[type="radio"]:checked')
      .forEach(function (input) {
        if (input.value) out.push(input.value);
      });
    document
      .querySelectorAll('.variant-input-wrap select, select[data-index]')
      .forEach(function (select) {
        if (select.value) out.push(select.value);
      });
    return out;
  }

  function syncToVariant(dialog) {
    var values = selectedValues();
    if (!values.length) return;
    var found = panels(dialog).filter(function (panel) {
      return values.indexOf(panel.getAttribute('data-raw-value')) !== -1;
    })[0];
    if (found) activate(dialog, found.getAttribute('data-size-guide-panel'));
  }

  /* Drawer'i body'ye tasi. Ayni id ile eski bir kopya varsa once onu kaldir,
     boylece AJAX ile yeniden render edilen urun bloklari cogaltmaz. */
  function moveToBody(dialog) {
    if (moved.has(dialog)) return;
    moved.add(dialog);

    var id = dialog.id;
    if (id) {
      document.querySelectorAll('body > dialog[data-size-guide]').forEach(function (old) {
        if (old !== dialog && old.id === id) old.remove();
      });
    }
    if (dialog.parentNode !== document.body) {
      document.body.appendChild(dialog);
    }
  }

  function isModal(dialog) {
    try {
      return dialog.matches(':modal');
    } catch (e) {
      /* :modal desteklenmiyorsa modal varsay, dokunma. */
      return true;
    }
  }

  function openFallback(dialog) {
    dialog.setAttribute('open', '');
    dialog.classList.add('size-guide--fallback');
  }

  function open(dialog) {
    moveToBody(dialog);
    syncToVariant(dialog);

    if (typeof dialog.showModal !== 'function') {
      openFallback(dialog);
      return;
    }

    /* Modal olmayan bir <dialog> top layer'a girmez: tarayici ona
       position: absolute verir, arka plan kararmaz ve panel sayfanin akisina
       gore konumlanir. Zaten 'open' ama modal degilse showModal() bir daha
       cagrilamaz (InvalidStateError), o yuzden once kapatiyoruz. */
    if (dialog.open && !isModal(dialog)) {
      dialog.close();
      dialog.classList.remove('size-guide--fallback');
    }

    if (!dialog.open) {
      try {
        dialog.showModal();
      } catch (e) {
        openFallback(dialog);
      }
    }
  }

  function close(dialog) {
    /* Sinif her iki yolda da temizlenmeli: fallback ile acilmis bir panel
       dialog.close() dalindan gecerse sinif uzerinde kalir ve sonraki modal
       acilista ::backdrop uzerine ikinci bir karartma biner. */
    dialog.classList.remove('size-guide--fallback');

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  /* Capture fazi: tetikleyici Size secenegin <label> satirinda duruyor, yani
     tiklama aksi halde label'i aktive eder ve variant-label-fix.js uzerinden
     varyant secimini degistirir. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-size-guide-open]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      var dialog = document.getElementById(trigger.getAttribute('data-size-guide-open'));
      if (dialog) open(dialog);
      return;
    }

    var closer = target.closest('[data-size-guide-close]');
    if (closer) {
      event.preventDefault();
      var owner = closer.closest('[data-size-guide]');
      if (owner) close(owner);
      return;
    }

    var tab = target.closest('[data-size-guide-tab]');
    if (tab) {
      event.preventDefault();
      var host = tab.closest('[data-size-guide]');
      if (host) activate(host, tab.getAttribute('data-size-guide-tab'));
      return;
    }

    /* Backdrop: tiklama dialog'un kendisine geldiyse (icerige degil) kapat. */
    if (target.matches('dialog[data-size-guide]')) {
      close(target);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var tab = event.target.closest && event.target.closest('[data-size-guide-tab]');
    if (!tab) return;
    var host = tab.closest('[data-size-guide]');
    if (!host) return;
    var all = tabs(host);
    var i = all.indexOf(tab);
    var next = all[event.key === 'ArrowRight' ? i + 1 : i - 1];
    if (!next) return;
    event.preventDefault();
    activate(host, next.getAttribute('data-size-guide-tab'));
    next.focus();
  });

  /* "Dimensions" gallery slide (size-guide.liquid, sg_mode 'slide'): one panel
     per size, only the selected one shown, plus size chips. A chip checks the
     buy box's own Size radio and fires its change event, so price, URL and
     sticky bar follow the normal variant path; theme.js keeps the gallery on
     the slide when only the size changed. */
  function slideInput(slide, value, handle) {
    var root = slide.closest('.product-section') || document;
    handle = handle || slide.getAttribute('data-size-handle');
    var inputs = root.querySelectorAll(
      'fieldset[data-handle="' + handle + '"] input[data-variant-input]'
    );
    for (var i = 0; i < inputs.length; i++) {
      if (value === undefined ? inputs[i].checked : inputs[i].value === value) return inputs[i];
    }
    return null;
  }

  function syncSlide(slide) {
    var checked = slideInput(slide);
    if (!checked) return;
    var value = checked.value;
    var parts = slide.querySelectorAll('[data-size-guide-panel]');
    var found = Array.prototype.some.call(parts, function (el) {
      return el.getAttribute('data-raw-value') === value;
    });
    /* A size the guide can't draw ('Medium Set'): the last drawing stays,
       but no chip claims to be the selected size. */
    if (found) {
      parts.forEach(function (el) {
        el.hidden = el.getAttribute('data-raw-value') !== value;
      });
    }
    var chips = slide.querySelectorAll('[data-size-guide-chip]');
    var anyChecked = false;
    chips.forEach(function (chip) {
      var chipValue = chip.getAttribute('data-size-guide-chip');
      var on = chipValue === value;
      if (on) anyChecked = true;
      /* radio group: the checked chip is the one Tab reaches (roving tabindex) */
      chip.setAttribute('aria-checked', on ? 'true' : 'false');
      chip.tabIndex = on ? 0 : -1;
      /* Same as the buy box: a size the other options don't come in is struck through. */
      var input = slideInput(slide, chipValue);
      chip.classList.toggle('is-unavailable', !!(input && input.classList.contains('disabled')));
    });
    if (!anyChecked && chips[0]) chips[0].tabIndex = 0;
    slide.querySelectorAll('.iwa-dim__chips').forEach(pressedInView);
  }

  /* Look row (snippets/size-guide-colours): one radio group per other option
     (colour, Style, Option...). Each group's checked chip follows the buy
     box's radio of that option; a value the other choices don't come in is
     struck through, like the sizes. */
  function syncOpts(slide) {
    slide.querySelectorAll('[data-opt-handle]').forEach(function (group) {
      var handle = group.getAttribute('data-opt-handle');
      var checked = slideInput(slide, undefined, handle);
      var chips = group.querySelectorAll('[data-size-guide-opt]');
      var anyChecked = false;
      chips.forEach(function (chip) {
        var chipValue = chip.getAttribute('data-size-guide-opt');
        var on = !!checked && chipValue === checked.value;
        if (on) anyChecked = true;
        chip.setAttribute('aria-checked', on ? 'true' : 'false');
        chip.tabIndex = on ? 0 : -1;
        var input = slideInput(slide, chipValue, handle);
        chip.classList.toggle('is-unavailable', !!(input && input.classList.contains('disabled')));
      });
      if (!anyChecked && chips[0]) chips[0].tabIndex = 0;
    });
  }

  /* Keep the selected chip in view when the row scrolls. The slideshow hides
     slides that are off screen (no layout), so this runs again from the
     ResizeObserver when the row is shown. */
  function pressedInView(row) {
    /* the look row has a checked chip per group: the group last changed */
    var chip = (lastHandle && row.querySelector('[data-opt-handle="' + lastHandle + '"] [aria-checked="true"]')) ||
      row.querySelector('[aria-checked="true"]');
    if (!chip || row.scrollWidth <= row.clientWidth) return;
    /* by rectangles, so a right-to-left row (/ar) scrolls the same way */
    var r = row.getBoundingClientRect();
    var c = chip.getBoundingClientRect();
    if (c.left < r.left) row.scrollLeft += c.left - r.left - 16;
    else if (c.right > r.right) row.scrollLeft += c.right - r.right + 16;
  }

  var lastHandle = null;

  var rowObserver = window.ResizeObserver && new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { pressedInView(entry.target); });
  });

  var observed = new WeakSet();

  function syncSlides() {
    document.querySelectorAll('[data-size-guide-slide]').forEach(function (slide) {
      syncOpts(slide);
      syncSlide(slide);
      slide.querySelectorAll('.iwa-dim__chips').forEach(function (row) {
        if (rowObserver && !observed.has(row)) {
          observed.add(row);
          rowObserver.observe(row);
        }
      });
    });
  }

  document.addEventListener('click', function (event) {
    var chip = event.target && event.target.closest && event.target.closest('[data-size-guide-chip]');
    if (!chip) return;
    var slide = chip.closest('[data-size-guide-slide]');
    var input = slide && slideInput(slide, chip.getAttribute('data-size-guide-chip'));
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* A look chip (colour, Style...) checks the buy box's radio of its option
     the same way; the other options stay as they are. */
  document.addEventListener('click', function (event) {
    var chip = event.target && event.target.closest && event.target.closest('[data-size-guide-opt]');
    if (!chip) return;
    var slide = chip.closest('[data-size-guide-slide]');
    var group = chip.closest('[data-opt-handle]');
    var handle = group && group.getAttribute('data-opt-handle');
    var input = slide && handle && slideInput(slide, chip.getAttribute('data-size-guide-opt'), handle);
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Arrow keys move through a group's chips and pick the size, colour or
     style (radio group pattern); Home / End jump to the ends. Mirrored on
     right-to-left pages. */
  document.addEventListener('keydown', function (event) {
    var chip = event.target && event.target.closest && event.target.closest('[data-size-guide-chip], [data-size-guide-opt]');
    if (!chip) return;
    var group = chip.closest('[role="radiogroup"]') || chip.parentNode;
    var all = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
    var i = all.indexOf(chip);
    /* the group's direction: the chips themselves are left to right (size-guide.css) */
    var rtl = getComputedStyle(group).direction === 'rtl';
    var next = null;
    if (event.key === 'ArrowDown' || event.key === (rtl ? 'ArrowLeft' : 'ArrowRight')) next = all[(i + 1) % all.length];
    else if (event.key === 'ArrowUp' || event.key === (rtl ? 'ArrowRight' : 'ArrowLeft')) next = all[(i - 1 + all.length) % all.length];
    else if (event.key === 'Home') next = all[0];
    else if (event.key === 'End') next = all[all.length - 1];
    if (!next) return;
    /* capture phase + stop: the gallery slideshow would take the arrow keys too */
    event.preventDefault();
    event.stopPropagation();
    next.focus();
    next.click();
  }, true);

  /* The chip row sits inside the gallery slideshow: a press or swipe there
     must not drag the slides. */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var row = event.target && event.target.closest && event.target.closest('.iwa-dim__chips');
      if (row) event.stopPropagation();
    }, { capture: true, passive: true });
  });

  /* Per-look PNG (snippets/size-guide-pngs): a colour or style change swaps
     the piece in the slide and the drawer for that look's file. The map is
     only on the page when the product has two or more files, or a look with
     none: that look's piece is hidden in the drawer (empty box) rather than
     showing another design's. The slide never has such a look. */
  var pngMaps = null;

  /* Sets (size-guide-pngs "k", 2026-10-21): a set look's PNG holds every
     piece side by side, so its box takes the size's height and the file's
     own width / height ("r"); a single piece the declared width again. A size
     without a width (height-only option) is always drawn as a set. The width
     rule is hidden on a set (the total depends on the hanging gaps); the
     slide's description follows. Height and centre stay, so the vertical
     placement (--sg-head) holds. */
  function fitBox(box, set, ratio) {
    var w = parseFloat(box.getAttribute('data-sg-w')) || 0;
    var h = parseFloat(box.getAttribute('data-sg-h')) || 0;
    var room = parseFloat(box.getAttribute('data-sg-room')) || 0;
    if (!h || !room) return;
    set = set || !w;
    var drawn = set && ratio ? Math.round(h * ratio * 10) / 10 : (w || h);
    box.style.width = (drawn * 100 / room).toFixed(3) + '%';
    box.style.aspectRatio = drawn + ' / ' + h;
    box.classList.toggle('size-guide__box--set', set);
    var panel = box.closest('[data-sg-aria-set]');
    if (panel) panel.setAttribute('aria-label', panel.getAttribute(set ? 'data-sg-aria-set' : 'data-sg-aria-one'));
  }

  function swapPng(variantId) {
    if (!pngMaps) {
      pngMaps = [];
      document.querySelectorAll('script[data-sg-pngs]').forEach(function (el) {
        try {
          pngMaps.push({ owner: el.getAttribute('data-sg-pngs'), map: JSON.parse(el.textContent) });
        } catch (e) {}
      });
    }
    pngMaps.forEach(function (entry) {
      var i = entry.map.v[String(variantId)];
      /* another product's variant (a quick add elsewhere on the page) */
      if (i === undefined) return;
      var url = i < 0 ? null : entry.map.u[i];
      var set = (entry.map.k || []).map(String).indexOf(String(variantId)) !== -1;
      var ratio = i < 0 || !entry.map.r ? 0 : entry.map.r[i];
      document.querySelectorAll('[data-sg-box="' + entry.owner + '"]').forEach(function (box) {
        fitBox(box, set, ratio);
      });
      document.querySelectorAll('img[data-sg-png="' + entry.owner + '"]').forEach(function (img) {
        img.hidden = !url;
        img.parentNode.classList.toggle('size-guide__box--empty', !url);
      });
      if (!url) return;
      var small = url.replace(/([?&]width=)\d+/, '$1600');
      document.querySelectorAll('img[data-sg-png="' + entry.owner + '"]').forEach(function (img) {
        if (img.getAttribute('data-sg-current') === url) return;
        img.setAttribute('data-sg-current', url);
        /* a slide image not released yet (see releaseSlideImages) only gets
           its pending address changed */
        if (img.hasAttribute('data-sg-src')) {
          img.setAttribute('data-sg-src', small);
          img.setAttribute('data-sg-srcset', small + ' 600w, ' + url + ' 1200w');
          return;
        }
        img.srcset = small + ' 600w, ' + url + ' 1200w';
        img.src = small;
      });
    });
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && variant.id) swapPng(variant.id);
  });

  /* The Dimensions slide's scene images come as data-sg-src / data-sg-srcset
     (size-guide-visual, sg_defer): on phones the slide is within the lazy-load
     distance and its ~100 KB went out next to the LCP image. They get their
     real addresses 3 s after load (like the deferred scripts) or as soon as
     the visitor heads for the slide: its thumb, a touch on the gallery, or
     the slide becoming the selected one. */
  var slideImagesOut = false;

  function releaseSlideImages() {
    if (slideImagesOut) return;
    slideImagesOut = true;
    document.querySelectorAll('[data-size-guide-slide] img[data-sg-src]').forEach(function (img) {
      var set = img.getAttribute('data-sg-srcset');
      if (set) img.srcset = set;
      img.src = img.getAttribute('data-sg-src');
      img.removeAttribute('data-sg-srcset');
      img.removeAttribute('data-sg-src');
    });
  }

  function releaseSoon() {
    window.setTimeout(releaseSlideImages, 3000);
  }
  if (document.readyState === 'complete') releaseSoon();
  else window.addEventListener('load', releaseSoon);

  ['pointerdown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var t = event.target;
      if (t && t.closest && t.closest('.product-slideshow, .product__thumbs')) releaseSlideImages();
    }, { capture: true, passive: true });
  });
  document.addEventListener('focusin', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('.product__thumb--dims, [data-size-guide-slide]')) releaseSlideImages();
  });
  if (window.MutationObserver) {
    var slideWatch = new MutationObserver(function () {
      if (document.querySelector('.product-main-slide--dims.is-selected')) {
        releaseSlideImages();
        slideWatch.disconnect();
      }
    });
    var watchSlides = function () {
      document.querySelectorAll('.product-main-slide--dims').forEach(function (slide) {
        slideWatch.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSlides);
    else watchSlides();
  }

  /* The slide is taller than the photos (its option rows sit under the scene,
     2026-10-24) and the gallery takes the selected slide's height
     (adaptiveHeight; theme.css animates it). When that change happens while
     the gallery's top is above the viewport, say a size picked in the buy box
     sends the gallery to the slide (theme.js updateVariantImage), the page
     would shift under the visitor's finger: scroll by the same amount, so
     what is on screen stays where it is. A swipe or tap in the gallery itself
     is left alone: there the visitor is looking at the slide, which grows
     downwards. Browsers with scroll anchoring (overflow-anchor: Chrome,
     Firefox) already do this on their own, and doing it twice moved the page
     by double the change (seen on the dev preview); only the others get it. */
  var galleryTouch = false;
  ['pointerdown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var t = event.target;
      galleryTouch = !!(t && t.closest && t.closest('.product__photos'));
    }, { capture: true, passive: true });
  });

  function keepPageStill() {
    if (!window.ResizeObserver) return;
    if (window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto')) return;
    document.querySelectorAll('[data-size-guide-slide]').forEach(function (slide) {
      var viewport = slide.closest('.flickity-viewport');
      if (!viewport || observed.has(viewport)) return;
      observed.add(viewport);
      var last = viewport.getBoundingClientRect().height;
      new ResizeObserver(function () {
        var rect = viewport.getBoundingClientRect();
        var delta = rect.height - last;
        last = rect.height;
        if (!delta || rect.top >= 0 || galleryTouch) return;
        var html = document.documentElement;
        var was = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollBy(0, delta);
        html.style.scrollBehavior = was;
      }).observe(viewport);
    });
  }

  /* Rows in view (2026-10-24, owner: the rows must not end up below the fold
     or under the floating add-to-cart bar; on an iPhone 16 Pro Max the bar,
     shown after a pick on the slide, covered them). After the visitor opens
     the slide from its thumb, or picks a chip on it, the page scrolls up by
     what the rows lack to sit 8px above the viewport's bottom, or above the
     sticky add-to-cart bar while that shows (iwa-sticky-atc.js sets
     html.iwa-sticky-atc-on and --iwa-sticky-atc-h). Run after the gallery's
     height animation (0.35s) and the bar's slide-in (0.25s). Only these two
     deliberate actions: a variant picked in the buy box also brings the
     gallery to the slide, but the visitor is reading the buy box then. */
  function revealRows(dimsSlide) {
    window.setTimeout(function () {
      if (!dimsSlide.classList.contains('is-selected')) return;
      var under = dimsSlide.querySelector('.iwa-dim__under');
      if (!under) return;
      var root = document.documentElement;
      var bar = root.classList.contains('iwa-sticky-atc-on')
        ? parseFloat(getComputedStyle(root).getPropertyValue('--iwa-sticky-atc-h')) || 0
        : 0;
      var over = under.getBoundingClientRect().bottom - (window.innerHeight - bar - 8);
      if (over <= 1) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: Math.ceil(over), behavior: reduce ? 'auto' : 'smooth' });
    }, 450);
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var dims = null;
    if (t.closest('[data-size-guide-slide] [role="radio"]')) {
      dims = t.closest('.product-main-slide--dims');
    } else if (t.closest('.product__thumb--dims')) {
      var photos = t.closest('[data-product-images]');
      dims = photos && photos.querySelector('.product-main-slide--dims');
    }
    if (dims) revealRows(dims);
  });

  function resync() {
    syncSlides();
    /* The theme marks unavailable sizes after the change event; read them once that has run. */
    window.requestAnimationFrame(syncSlides);
    document.querySelectorAll('[data-size-guide]').forEach(function (dialog) {
      if (dialog.open) syncToVariant(dialog);
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('input[data-variant-input], select')) {
      var set = event.target.closest('fieldset[data-handle]');
      if (set) lastHandle = set.getAttribute('data-handle');
      resync();
    }
  });
  document.addEventListener('variant:change', resync);

  function start() {
    document.querySelectorAll('[data-size-guide]').forEach(moveToBody);
    /* the slideshow wraps the slides in its viewport after load */
    keepPageStill();
  }

  /* Slides once at load: the browser can restore a different checked radio on back/forward. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); resync(); });
  } else {
    start();
    resync();
  }

  /* AJAX ile eklenen urun bloklarini yakala. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      start();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
